import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 space-y-4 md:space-y-8"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "mt-8 md:mt-2"
}
const _hoisted_4 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_5 = { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }
const _hoisted_6 = { class: "pt-0 capitalize" }
const _hoisted_7 = { class: "pt-0 capitalize" }
const _hoisted_8 = { class: "pt-0 capitalize" }
const _hoisted_9 = { class: "pt-0 capitalize" }
const _hoisted_10 = { class: "pt-0 capitalize" }
const _hoisted_11 = { class: "w-full table-auto" }
const _hoisted_12 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_13 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_14 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_15 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_16 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_17 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_18 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_19 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_20 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_21 = { class: "pt-0 capitalize" }
const _hoisted_22 = { class: "pt-0 capitalize" }
const _hoisted_23 = {
  key: 0,
  class: "pt-0 capitalize"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "pt-0" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "pt-0" }
const _hoisted_28 = { class: "block my-1" }
const _hoisted_29 = ["href"]
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "pt-0" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "capitalize" }
const _hoisted_37 = { class: "capitalize" }
const _hoisted_38 = { class: "capitalize" }
const _hoisted_39 = { class: "capitalize" }
const _hoisted_40 = { class: "capitalize" }
const _hoisted_41 = { class: "px-4 py-4 bg-gray-100 border-t border-gray-400" }
const _hoisted_42 = {
  key: 0,
  class: "flex py-6"
}
const _hoisted_43 = {
  key: 1,
  class: "mt-8 min-h-12 bg-play-gray md:mt-2"
}
const _hoisted_44 = {
  key: 2,
  class: "mt-8 md:mt-2 h-fit"
}

import { ref, computed, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

import EventVisibilitySwitch from "@/components/events/EventVisibilitySwitch.vue";
import EventAttendeesTable from "@/components/tables/EventAttendeesTable.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import StoryblockDescription from "@/components/StoryblockDescription.vue";
import EventStatusSwitch from "@/components/events/EventStatusSwitch.vue";
import ReadonlyTags from "@/components/ReadonlyTags.vue";
import PriceDisplay from "@/components/PriceDisplay.vue";
import RouterButton from "@/components/RouterButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import AlertCard from "@/components/AlertCard.vue";
import RoleGuard from "@/components/RoleGuard.vue";
import TabGroup from "@/components/TabGroup.vue";

import api from "@/api/api";
import { Event, EventDateResponse } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";

import { useI18n } from "vue-i18n";
import { userHasRole } from "@/utils/roles";
import { deserializeSlug } from "@/utils/slugify";

export default /*#__PURE__*/_defineComponent({
  __name: 'EventPage',
  setup(__props) {

const { t: $t } = useI18n();

const trainerRoles = ["l4a-trainer", "trainer-organisation", "admin", "courses-admin", "facilitator-organisation"];
const attendeeRoles = ["certified-facilitator-trainee", "certified-facilitator", "advanced-facilitator-trainee", "advanced-facilitator", "professional", "paid-professional"];

const route = useRoute();
const router = useRouter();
const { user, timezone, orgRoles } = storeToRefs(useUserStore());
const globalStore = useGlobalStore();

const isLoading = ref(true);
const isCancelEventOpen = ref(false);
const isAttendee = userHasRole(user.value.roles, attendeeRoles);

const website_url = process.env.VUE_APP_WEBSITE_URL;

const noLevelEvents = ["introductory", "continuing-professional-development", "cpd-for-certified-facilitators"];
const asyncEventDelivery = ["e-learning"];

const event = ref({} as Event);
const story = ref({});
const tabs = [
  {
    id: "summary",
    name: "Summary",
    roles: [...trainerRoles, ...attendeeRoles],
  },
  {
    id: "course_description",
    name: "Course Description",
    roles: [...trainerRoles, ...attendeeRoles],
  },
  {
    id: "registered_attendees",
    name: "Registered Attendees",
    role: "trainer",
    roles: trainerRoles,
  },
];
const selectedTab = ref("summary");

const userIsAdmin = computed(() => {
  const adminRoles = ["admin", "courses-admin"];

  if (adminRoles.some(role => user.value.roles.some(userRole => userRole.name === role))) {
    return true;
  }

  // Show edit button if user is a TO in the same organisation
  if (user.value.roles.some(userRole => userRole.name === "trainer-organisation") && user.value.organisation_id === event.value.organisation_id) {
    return true;
  }

  return false;
});

function eventDateToLocal(eventDate: EventDateResponse, date: string) {
  if (eventDate.timezone === "UTC" || eventDate.timezone === timezone.value) {
    // Extract date portion only and construct at local noon to prevent UTC-to-local day shift
    const dateOnly = date.split("T")[0];
    const [year, month, day] = dateOnly.split("-").map(Number);
    return new Date(year, month - 1, day, 12, 0, 0).toDateString();
  }

  // Combine the event date and start time into a single datetime string
  const eventDateTimeString = `${eventDate.event_date.split("T")[0]}T${eventDate.start_time}`;

  // Convert the event's local time to UTC (universal time)
  const utcDate = zonedTimeToUtc(eventDateTimeString, eventDate.timezone);

  // Convert the UTC time to the user's local time based on their timezone
  const userDateTime = utcToZonedTime(utcDate, timezone.value);

  return userDateTime.toDateString();
}

// Convert event time to time of current user's timezone
function eventTimeToLocal(eventDate: EventDateResponse, time: string) {
  if (eventDate.timezone === "UTC") {
    return time;
  }

  // If the event date's timezone is the same as the user's timezone, return the time as is
  if (eventDate.timezone === timezone.value) {
    return time;
  }

  // Combine the event date and start time into a single datetime string
  const eventDateTimeString = `${eventDate.event_date.split("T")[0]}T${time}`;

  // Convert the event date's time to UTC (universal time)
  const utcDate = zonedTimeToUtc(eventDateTimeString, eventDate.timezone);

  // Convert the UTC time to the user's local time based on their timezone
  const userDateTime = utcToZonedTime(utcDate, timezone.value);

  return userDateTime.toLocaleTimeString();
}

function dateStringToLocal(dateStr: string): string {
  const dateOnly = dateStr.split("T")[0];
  const [year, month, day] = dateOnly.split("-").map(Number);
  return new Date(year, month - 1, day, 12, 0, 0).toDateString();
}

function getTimezoneAbbreviation(timezone: string): string {
  const date = new Date();
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: timezone,
    timeZoneName: "short",
  });

  const parts = formatter.formatToParts(date);

  const timeZoneName = parts.find(part => part.type === "timeZoneName");

  return timeZoneName ? timeZoneName.value : timezone;
}

async function updateEventVisibility(e: Event) {
  const isVisible = e.visibility;

  let data = {
    visibility: "",
  };

  if (isVisible) {
    data.visibility = "private";
  } else {
    data.visibility = "public";
  }

  try {
    const response = await api.events.updateEventVisibility(String(e.id), data);

    event.value.visibility = response.data.event.visibility;
    event.value.link_token = response.data.event.link_token;

    globalStore.toast("SUCCESS", $t("event-visibility-updated"));
  } catch (e) {
    globalStore.toast("ERROR", $t("there-was-an-error-updating-event-visibility"));
  }
}

async function updateEventStatus(status: string) {
  let data = {
    status: status,
  };

  try {
    const response = await api.events.updateEventStatus(String(event.value.id), data);

    event.value.status = response.data.event.status;

    globalStore.toast("SUCCESS", $t("event-updated"));
  } catch (e) {
    globalStore.toast("ERROR", $t("there-was-an-error-updating-this-event"));
  } finally {
    isCancelEventOpen.value = false;
  }
}

onMounted(async () => {
  try {
    isLoading.value = true;
    event.value = (await api.events.getEvent(String(route.params.id))).data.event;
    story.value = (await api.templates.getTemplateStory(event.value.template_id, event.value.template.storyblok_slug)).data.story;

    // Check if the user has a booking for this event
    if (userHasRole(user.value.roles, attendeeRoles)) {
      const { has_booking } = (await api.users.checkUserHasEventBooking(user.value.id, event.value.id)).data;

      if (!has_booking) {
        window.location.href = "/error";
      }
    }

    if (userHasRole(user.value.roles, ["parent", "brick-club-family"])) {
      window.location.href = "/error";
    }

    if (route.query.tab) {
      selectedTab.value = route.query.tab;
    }
    isLoading.value = false;
  } catch (e) {
    return router.push({ name: "Error" });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationModal, {
      isOpen: isCancelEventOpen.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isCancelEventOpen.value = false)),
      onDelete: _cache[1] || (_cache[1] = ($event: any) => (updateEventStatus('cancelled'))),
      buttonText: _unref($t)('confirm-event-cancellation')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(_unref($t)("this-will-cancel-the-event-and-notify-all-registered-attendees")), 1)
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "buttonText"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'l4a-trainer', 'trainer-organisation'] }, {
            default: _withCtx(() => [
              _createVNode(EventStatusSwitch, {
                event: event.value,
                user: _unref(user),
                onChange: updateEventStatus,
                onCancel: _cache[2] || (_cache[2] = ($event: any) => (isCancelEventOpen.value = true))
              }, null, 8, ["event", "user"])
            ]),
            _: 1
          }),
          (event.value.status === 'in review')
            ? (_openBlock(), _createBlock(RoleGuard, {
                key: 0,
                roles: ['l4a-trainer', 'trainer-organisation', 'admin']
              }, {
                default: _withCtx(() => [
                  _createVNode(AlertCard, {
                    "hide-icon": true,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref($t)("event-submission-message")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(TitleHeader, {
            title: event.value.name
          }, null, 8, ["title"]),
          _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
            default: _withCtx(() => [
              _createVNode(EventVisibilitySwitch, {
                event: event.value,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (updateEventVisibility(event.value)))
              }, null, 8, ["event"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(TabGroup, {
            tabs: tabs,
            selectedTab: selectedTab.value,
            onSelect: _cache[4] || (_cache[4] = (tab) => selectedTab.value = tab),
            "has-role-guard": true
          }, null, 8, ["selectedTab"]),
          (selectedTab.value === 'summary')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)("event-details")), 1),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('course')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(event.value.name), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  (!noLevelEvents.includes(event.value.template.type))
                    ? (_openBlock(), _createBlock(ListRowItem, {
                        key: 0,
                        title: _unref($t)('course-level')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(event.value.template.level), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createVNode(RoleGuard, {
                    roles: trainerRoles.filter(i => i !== 'facilitator-organisation')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ListRowItem, {
                        title: _unref($t)('course-type')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(deserializeSlug)(event.value.template.type)), 1)
                        ]),
                        _: 1
                      }, 8, ["title"])
                    ]),
                    _: 1
                  }, 8, ["roles"]),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('delivery-method')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(deserializeSlug)(event.value.template.delivery)), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(RoleGuard, {
                    roles: trainerRoles.filter(i => _unref(orgRoles).includes(i))
                  }, {
                    default: _withCtx(() => [
                      (event.value.template.delivery === 'live-webinar')
                        ? (_openBlock(), _createBlock(ListRowItem, {
                            key: 0,
                            title: _unref($t)('host-country')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_10, _toDisplayString(event.value.host_country), 1)
                            ]),
                            _: 1
                          }, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (event.value.template.type !== 'in-person')
                        ? (_openBlock(), _createBlock(ListRowItem, {
                            key: 1,
                            title: _unref($t)('available-countries')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.countries, (country) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "capitalize",
                                    key: country.id
                                  }, _toDisplayString(country.name), 1))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["roles"]),
                  (event.value.dates && event.value.dates.length && !asyncEventDelivery.includes(event.value.template.delivery))
                    ? (_openBlock(), _createBlock(ListRowItem, {
                        key: 1,
                        title: _unref($t)('date-and-time'),
                        flex: false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("table", _hoisted_11, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_12, [
                                _createElementVNode("th", _hoisted_13, _toDisplayString(_unref($t)("date")), 1),
                                _createElementVNode("th", _hoisted_14, _toDisplayString(_unref($t)("start-time")), 1),
                                _createElementVNode("th", _hoisted_15, _toDisplayString(_unref($t)("end-time")), 1),
                                _createElementVNode("th", _hoisted_16, _toDisplayString(_unref($t)("timezone")), 1)
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.dates, (date, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  class: "border-b border-gray-400 divide-x-2 divide-gray-400 odd:bg-gray-200",
                                  key: index
                                }, [
                                  _createElementVNode("td", _hoisted_17, _toDisplayString(new Date(eventDateToLocal(date, date.event_date)).toDateString()), 1),
                                  _createElementVNode("td", _hoisted_18, _toDisplayString(eventTimeToLocal(date, date.start_time)), 1),
                                  _createElementVNode("td", _hoisted_19, _toDisplayString(eventTimeToLocal(date, date.end_time)), 1),
                                  _createElementVNode("td", _hoisted_20, _toDisplayString(getTimezoneAbbreviation(_unref(timezone))), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('language')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(event.value.language), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  (event.value.template.delivery === 'in-person')
                    ? (_openBlock(), _createBlock(ListRowItem, {
                        key: 2,
                        title: _unref($t)('location')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(event.value.address_line_one), 1),
                          _createElementVNode("p", null, _toDisplayString(event.value.address_line_two), 1),
                          _createElementVNode("p", null, _toDisplayString(event.value.city) + ", " + _toDisplayString(event.value.postcode), 1),
                          _createElementVNode("p", _hoisted_22, _toDisplayString(event.value.country ? event.value.country : event.value.host_country), 1),
                          (event.value.maps_link)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                                _createElementVNode("a", {
                                  target: "_blank",
                                  class: "text-link",
                                  href: event.value.maps_link
                                }, _toDisplayString(_unref($t)("show-on-google-maps")), 9, _hoisted_24)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  (event.value.template.delivery !== 'in-person')
                    ? (_openBlock(), _createBlock(ListRowItem, {
                        key: 3,
                        title: _unref($t)('training') + ' link'
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_25, [
                            _createElementVNode("a", {
                              class: "underline text-blue",
                              href: `https://${event.value.meeting_link}`,
                              target: "_blank"
                            }, _toDisplayString(_unref(isAttendee) ? _unref($t)("access-training") : event.value.meeting_link), 9, _hoisted_26)
                          ])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('organisation')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(event.value.organisation.name), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  (event.value.presenters.length)
                    ? (_openBlock(), _createBlock(ListRowItem, {
                        key: 4,
                        title: _unref($t)('presenters'),
                        "center-label": false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.presenters, (presenter, index) => {
                            return (_openBlock(), _createElementBlock("p", {
                              class: "pt-0",
                              key: index
                            }))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.presenters, (presenter, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex justify-between py-2 border-b border-gray-300 last:border-none"
                            }, [
                              _createElementVNode("span", _hoisted_28, _toDisplayString(presenter.first_name) + " " + _toDisplayString(presenter.last_name), 1)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createVNode(ListRowItem, {
                    title: _unref($t)('contact-trainer'),
                    "center-label": false
                  }, {
                    default: _withCtx(() => [
                      (event.value.organisation.name.toLowerCase() === 'play included')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: `${_unref(website_url)}/contact-us/`,
                            class: "pt-0 underline capitalize text-primary",
                            target: "_blank"
                          }, _toDisplayString(_unref($t)("contact-trainer")), 9, _hoisted_29))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: `mailto:${event.value.owner.email}`,
                            class: "pt-0 underline capitalize text-blue",
                            target: "_blank"
                          }, _toDisplayString(_unref($t)("contact-trainer")), 9, _hoisted_30))
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(RoleGuard, {
                    roles: trainerRoles.filter(i => !_unref(orgRoles).includes(i))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ListRowItem, {
                        title: _unref($t)('event-owner')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_31, _toDisplayString(event.value.owner.first_name) + " " + _toDisplayString(event.value.owner.last_name), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      _createVNode(ListRowItem, {
                        title: _unref($t)('price')
                      }, {
                        default: _withCtx(() => [
                          (!event.value.trainer_pricing && !event.value.host_country)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createVNode(PriceDisplay, {
                                  locale: "en-GB",
                                  price: event.value.template.countries[0].pricing,
                                  currency: event.value.template.countries[0].currency,
                                  vat: event.value.template.countries[0].vat
                                }, null, 8, ["price", "currency", "vat"])
                              ]))
                            : (!event.value.trainer_pricing && event.value.host_country)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createVNode(PriceDisplay, {
                                    locale: "en-GB",
                                    price: event.value.template.countries.find(i => i.country === event.value.host_country!)!.pricing,
                                    currency: event.value.template.countries.find(i => i.country === event.value.host_country!)!.currency,
                                    vat: event.value.template.countries.find(i => i.country === event.value.host_country!)?.vat
                                  }, null, 8, ["price", "currency", "vat"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _createVNode(PriceDisplay, {
                                    locale: "en-GB",
                                    price: event.value.trainer_pricing!,
                                    currency: event.value.trainer_currency!,
                                    "trainer-tax": event.value.trainer_tax_status
                                  }, null, 8, ["price", "currency", "trainer-tax"])
                                ]))
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      (event.value.payment_link)
                        ? (_openBlock(), _createBlock(ListRowItem, {
                            key: 0,
                            title: _unref($t)('payment-link')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, [
                                _createElementVNode("a", {
                                  class: "underline text-blue",
                                  href: `https://${event.value.payment_link}`,
                                  target: "_blank"
                                }, _toDisplayString(event.value.payment_link), 9, _hoisted_35)
                              ])
                            ]),
                            _: 1
                          }, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (event.value.payment_gateway)
                        ? (_openBlock(), _createBlock(ListRowItem, {
                            key: 1,
                            title: _unref($t)('payment-gateway')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_36, _toDisplayString(event.value.payment_gateway), 1)
                            ]),
                            _: 1
                          }, 8, ["title"]))
                        : _createCommentVNode("", true),
                      _createVNode(ListRowItem, {
                        title: _unref($t)('minimum-attendees')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_37, _toDisplayString(event.value.min_attendees ? event.value.min_attendees : "0"), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      _createVNode(ListRowItem, {
                        title: _unref($t)('maximum-attendees')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_38, _toDisplayString(event.value.max_attendees ? event.value.max_attendees : _unref($t)("unlimited")), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      (event.value.publish_at)
                        ? (_openBlock(), _createBlock(ListRowItem, {
                            key: 2,
                            title: _unref($t)('go-live')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_39, _toDisplayString(dateStringToLocal(event.value.publish_at)), 1)
                            ]),
                            _: 1
                          }, 8, ["title"]))
                        : _createCommentVNode("", true),
                      (event.value.register_by)
                        ? (_openBlock(), _createBlock(ListRowItem, {
                            key: 3,
                            title: _unref($t)('registration-cut-off-date')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_40, _toDisplayString(dateStringToLocal(event.value.register_by)), 1)
                            ]),
                            _: 1
                          }, 8, ["title"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(ReadonlyTags, {
                          tags: event.value.tags!
                        }, null, 8, ["tags"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["roles"])
                ]),
                ((_unref(user).id === event.value.user_id && event.value.status !== 'published') || _unref(userIsAdmin))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createVNode(RouterButton, {
                        type: "primary",
                        to: { name: 'Edit_Training_Event', params: { id: event.value.id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref($t)("edit-training-event")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'course_description')
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                (story.value && story.value.uuid)
                  ? (_openBlock(), _createBlock(StoryblockDescription, {
                      key: 0,
                      class: "pt-6",
                      story: story.value
                    }, null, 8, ["story"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'registered_attendees')
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createVNode(EventAttendeesTable, { event: event.value }, null, 8, ["event"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})